import React from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationFuncProp } from '../../../common/types/prop-types/common';
import cssForms from '../../assets/scss/Forms.scss';
import SurveyFollowupContainer, { SurveyFollowupContainerProps, SurveyFollowupProps } from './containers/SurveyFollowupContainer';
import css from './SurveyFollowup.scss';

import { TFunction } from 'i18next';
import { config } from '../../common';
import { useRouter } from '../../common/RouterHooks';
import TopNav from '../../main/components/TopNav';

const EmailForm: React.FC<SurveyFollowupProps & TranslationFuncProp> = (props) => {
    return (
        <React.Fragment>
            <div className={[cssForms.input, cssForms.required, 'col-12'].join(' ')} hidden={props.name.hideElem}>
                <label>
                    <span>{props.t('surveyfollowup:formFields.name')}</span>
                    <input {...props.name.inputProps} />
                    <div className="error-message">{props.name.errorText}</div>
                </label>
            </div>
            <div className={[cssForms.input, cssForms.required, 'col-12'].join(' ')} hidden={props.email.hideElem}>
                <label>
                    <span>{props.t('surveyfollowup:formFields.email')}</span>
                    <input {...props.email.inputProps} />
                    <div className="error-message">{props.email.errorText}</div>
                </label>
            </div>

            <div className={cssForms.bottomBoxSignup} />

            <div className={css.fullWidth}>
                {submitButton(props, props.t)}
            </div>
        </React.Fragment>
    );
};

function submitButton(props: SurveyFollowupProps, t: TFunction) {
    return (
        <div className={[cssForms.buttons, 'col-12'].join(' ')}>
            <div className={[cssForms.bmwButton, cssForms.blue, cssForms.submit].join(' ')} {...props.btnSurveyFollowup}>{props.btnSurveyFollowup.disabled ? t('loadingText') : t('send')}</div>
        </div>
    );
}

const SurveyFollowup: React.FC<SurveyFollowupContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <SurveyFollowupContainer {...containerProps} t={t} routeProps={routeProps}>
            {(props) => {
                return (
                    <div className={cssForms.container} id="surveyfollowup-form">
                        <TopNav
                            items={[
                                {
                                    to: `${config.UnauthBaseUrl}`,
                                    label: t('breadcrumbs.init'),
                                },
                                {
                                    to: '#',
                                    label: t('breadcrumbs.gatherdata'),
                                },
                            ]}
                        />
                        <div className={cssForms.topSections}>
                            <section className={[cssForms.textSection, cssForms.rem].join(' ')}>
                                <div className={cssForms.textSectionWrapper}>
                                    <h3>{t(`surveyfollowup:introText.text1`)}</h3>
                                    <h1>{t(`surveyfollowup:introText.text2`)}</h1>
                                    <p>{t(`surveyfollowup:introText.text3`)}</p>
                                </div>
                            </section>
                        </div>
                        <div className={cssForms.formContainer}>
                            <form className={cssForms.form}>
                                <div className={cssForms.rem}><h3><b className={cssForms.blue}>{t('surveyfollowup:introText.text4')}</b></h3></div>
                                <div className={[cssForms.formPage, cssForms.tOpacity, cssForms.tOpacityVisible, 'row'].join(' ')}>
                                    <EmailForm t={t} {...props} />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </SurveyFollowupContainer>
    );
};

export default SurveyFollowup;
